import React, { useState } from 'react';
import RelatedBook from './RelatedBook';
import { useLocation, useNavigate } from 'react-router-dom';
import { IMG_BASE_URL } from '../Helpers';
import SameAuthorBooks from './SameAuthorBooks';
import AuthorDetails from './AuthorDetails';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAmazon } from "@fortawesome/free-brands-svg-icons";
import { whatsappConfig } from '../whatsappConfig'; // Adjusted path to match previous context
import SEO from '../seo/SEO';              // Import SEO Component
import { getBookSEO } from '../seo/BookSEO'; // Import Book Logic
import { NavLink } from "react-router-dom";
import { getDiscountedPrice } from '../Utils';

export default function BookDetails() {
    const [navbarOpen, setNavbarOpen] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();
    const { book } = location.state || {};

    // Generate SEO Data immediately
    const seoData = getBookSEO(book);

    if (!book) {
        return <p>No book data found.</p>;
    }
    const goToAuthor = (author) => {
        navigate('/author', { state: { author } });
    };

    const handleNavLinkClick = () => {
        window.scrollTo(0, 0);
        setNavbarOpen(false);
    };
    const orderViaWhatsApp = () => {
        const cleanNumber = whatsappConfig.phoneNumber.replace(/[+\s]/g, "");

        const msg = `Hi, I want to order the book : *${book.book_name}*\n \written by : *${book.authors[0].author_name}*\nPlease share details.`;

        const encodedMsg = encodeURIComponent(msg);

        const url = `https://wa.me/${cleanNumber}?text=${encodedMsg}`;

        window.open(url, "_blank");
    };


    return (
        <>
            {/* Inject Dynamic Book SEO */}
            <SEO {...seoData} />

            <section className="py-5">
                <div className="container px-4 px-lg-5 my-5">
                    <div className="row gx-4 gx-lg-5 align-items-center">
                        {/* Updated alt tag for SEO */}
                        <div className="col-md-6"><img className="card-img-top mb-5 mb-md-0" src={IMG_BASE_URL + "books/" + book.image} alt={book.book_name} /></div>
                        <div className="col-md-6">
                            {/* <div className="small mb-1">SKU: BST-498</div> */}
                            <h1 className="display-5 fw-bolder">{book.book_name}</h1>
                            <h5>By :
                                {book?.authors?.map((item, index) => (
                                    <a className="btn btn-outline-dark mt-auto me-2" onClick={() => goToAuthor(item)} key={index}>{item.author_name}</a>
                                ))}</h5>
                            <h5>Category : {book.category_name}</h5>
                            <h5>Number of Pages : {book.no_of_pages}</h5>
                            <h5>Binding : {book.binding}</h5>
                            <h5>Publishing Year : {book.published_year}</h5>

                            <div className="fs-5 mb-5">
                                <span className="text-decoration-line-through">&#8377; {book.mrp}</span>
                                <span>&nbsp; &#8377; {getDiscountedPrice(book.mrp, book.discount_percent).toFixed(2)} </span>
                            </div>
                            <p className="lead">
                                <span dangerouslySetInnerHTML={{ __html: book.description }}></span>
                            </p>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-6">
                                        {book.amazon_link && (
                                            <a className="btn btn-outline-dark flex-shrink-0 image-button"
                                                target="_blank"
                                                href={book.amazon_link}>
                                                Buy from
                                                <FontAwesomeIcon icon={faAmazon} size="2x" />
                                            </a>
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        {book.flipkart_link && (
                                            <a className="btn btn-outline-dark flex-shrink-0 image-button"
                                                target='_blank'
                                                href={book.flipkart_link}>
                                                Buy from Flipkart
                                                <i className="bi-cart-fill me-1 fs-3"></i>
                                            </a>
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        <a
                                            onClick={orderViaWhatsApp}
                                            className="btn btn-success flex-shrink-0 image-button"
                                        >
                                            Order via WhatsApp
                                            <i className="bi bi-whatsapp ms-2 fs-4"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <RelatedBook categoryId={book.category_id} bookId={book.book_id} key={book.book_id} />
            {
                book?.authors?.map((item, index) => (
                    < AuthorDetails author={item} bookId={book.book_id} key={book.book_id} />
                ))
            }
            <section className="py-5">
                <div className="container px-4 px-lg-5 my-5">
                    <div className="row gx-4 gx-lg-5 align-items-center">
                        <p className="lead fw-normal text-muted mb-4">
                            പുസ്തകങ്ങൾ വഴി അറിവും സംസ്‌കാരവും പ്രചരിപ്പിക്കുന്നത് ഉയിർമൊഴിയുടെ ലക്ഷ്യം. ഉയിർമൊഴി എന്നത് മികച്ച ഗ്രന്ഥങ്ങൾ പ്രസിദ്ധീകരിക്കുന്നതിലൂടെ വായനക്കാരെ പ്രചോദിപ്പിക്കുന്നതിന് രൂപകൽപ്പന ചെയ്ത ഒരു പ്രസിദ്ധീകരണ സ്ഥാപനമാണ്. നമുക്ക് ലഭ്യമായതും, പ്രീമിയം ഗ്രന്ഥങ്ങളും നിങ്ങളുടെ അറിവും സൃഷ്ടിപരവും വർധിപ്പിക്കും.
                            <NavLink
                                className="btn btn-outline btn-primary btn-lg px-4"
                                to="/become-publisher"
                                onClick={handleNavLinkClick}
                            >
                                Learn More
                            </NavLink>
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}